import {
  type UseMutationResult,
  useMutation,
  useQueryClient,
} from "@tanstack/react-query";
import { apiPost } from "@/shared/api";
import { useCurrentBoardSlug } from "@/shared/hooks/useCurrentBoardSlug";

interface SubmitThreadParams {
  mode: "thread";
  formData: FormData;
}

interface SubmitReplyParams {
  mode: "reply";
  threadId: string;
  formData: FormData;
}

type SubmitParams = SubmitThreadParams | SubmitReplyParams;

export function useSubmitPost(): UseMutationResult<
  unknown,
  unknown,
  SubmitParams
> {
  const queryClient = useQueryClient();
  const slug = useCurrentBoardSlug();

  return useMutation({
    mutationFn: async (params: SubmitParams): Promise<unknown> => {
      if (params.mode === "thread") {
        return apiPost(`/threads/${slug}`, params.formData);
      }
      return apiPost(`/posts/${slug}/${params.threadId}`, params.formData);
    },
    onSuccess: (_: unknown, params: SubmitParams): void => {
      if (params.mode === "thread") {
        queryClient.invalidateQueries({ queryKey: ["threads", slug] });
      } else {
        queryClient.invalidateQueries({
          queryKey: ["thread", slug, params.threadId],
        });
      }
    },
    onError: (error: unknown): void => {
      alert(error instanceof Error ? error.message : "投稿に失敗しました");
    },
  });
}
